import React, { useMemo, useState } from "react";
import ProjectCard from "./ProjectCard";
import PrimaryButton from './PrimaryButton';
import { projectsData } from "../data/projectsData";

const Projects = () => {
    const [showAll, setShowAll] = useState(false);
    const visibleProjects = useMemo(() => showAll ? projectsData : projectsData.slice(0, 2), [showAll]);

    return (
        <section className="w-full flex items-center justify-center dark:bg-earth-900 py-20 overflow-hidden">
            <div className="w-full max-w-7xl px-8 lg:px-6">
                <div className="flex flex-col items-center justify-center">
                    <h2 className="mb-8 w-full text-right text-4xl font-bold leading-tight text-earth-900 dark:text-earth-50 sm:text-5xl lg:text-6xl">
                        Projects
                    </h2>

                    <div className="flex w-full flex-col gap-16">
                        {visibleProjects.map((project, index) => (
                            <ProjectCard
                                key={project.slug}
                                title={project.title}
                                description={project.description}
                                image={project.image}
                                imageAlt={project.imageAlt}
                                link={`/projects/${project.slug}`}
                                reverse={index % 2 !== 0}
                            />
                        ))}
                    </div>

                    {projectsData.length > 2 ? (
                        <div className="mt-12 w-full flex justify-center">
                            <PrimaryButton onClick={() => setShowAll((prev) => !prev)}>
                                {showAll ? 'View less' : 'View more'}
                            </PrimaryButton>
                        </div>
                    ) : null}
                </div>
            </div>
        </section>
    );
};

export default Projects;